<app-popover (closeCallback)="cancelCallback()" size="small" titleText="Select Garage">
  <div popover-content>
    <div class="existing-garage" *ngIf="existingGarage && existingGarage.garageType">
      <label>Existing Garage: </label>
      <div>{{(existingGarage.garageType == 'office' || existingGarage.garageType == 'vendor') ?
        existingGarage.garageAddress : existingGarage.garageLabel}}</div>
    </div>
    <form *ngIf="formDetails" [formGroup]="formDetails">
      <div class="options">
        <app-radio-button
          class="option"
          [option]="options[0]"
          [selectedValue]="garageType"
          name="garageTypeRadio"
          (changeCallback)="onTypeChange($event)">
        </app-radio-button>
        <app-radio-button
          class="option"
          [option]="options[1]"
          [selectedValue]="garageType"
          name="garageTypeRadio"
          (changeCallback)="onTypeChange($event)">
        </app-radio-button>
      </div>
      <div class="options" *ngIf="offices.length">
        <app-radio-button
          class="option"
          [option]="options[2]"
          [selectedValue]="garageType"
          name="garageTypeRadio"
          (changeCallback)="onTypeChange($event)">
        </app-radio-button>
        <app-select
          class="option"
          type="dropdown"
          [formControl]="formDetails.get('office')"
          [getCustomOptionValue]="getOptionValue"
          [getCustomOptionLabel]="getOptionLabel"
          [options]="offices">
        </app-select>
      </div>
      <div class="options" *ngIf="garages.length">
        <app-radio-button
          class="option"
          [option]="options[3]"
          [selectedValue]="garageType"
          name="garageTypeRadio"
          (changeCallback)="onTypeChange($event)">
        </app-radio-button>
        <app-select
          class="option"
          type="dropdown"
          [formControl]="formDetails.get('garage')"
          [getCustomOptionValue]="getOptionValue"
          [getCustomOptionLabel]="getOptionLabel"
          [options]="garages">
        </app-select>
      </div>
    </form>
  </div>
  <div popover-actions>
    <app-button (clickCallback)="cancelCallback()" class="mr-10" type="plainText" text="Cancel"></app-button>
    <app-button (clickCallback)="onSubmitClick()" type="primaryFilled" text="Submit"></app-button>
  </div>
</app-popover>

<app-dialog *ngIf="garageError" titleText="Error" (approveCallback)="hideGarageError()"  type="alert" [buttonText]="['Ok']">
    {{garageError}}
 </app-dialog>

 <app-loader *ngIf="isLoading"></app-loader>
